import * as React from 'react';
import Checkbox from 'src/components/FormElements/Checkbox';
import { IDepartment } from 'src/Entities/Departments';
import { getDepartments } from 'src/helpers/api';

type OrganizerSelectProps = {
  value: number[];
  onChange: (value: number[]) => void;
  initiallySelectAll?: boolean;
};

const OrganizerSelect = ({
  value,
  onChange,
  initiallySelectAll = false,
}: OrganizerSelectProps) => {
  const [departments, setDepartments] = React.useState<IDepartment[]>([]);

  React.useEffect(() => {
    getDepartments()
      .then((nextDepartments) => {
        setDepartments(nextDepartments);

        if (initiallySelectAll) {
          onChange(nextDepartments.map((department) => department.id));
        }
      });
  }, []);

  return (
    <div className="flex flex-column">
      {departments.map((department) => (
        <Checkbox
          key={department.id}
          className="mt1"
          checked={value.indexOf(department.id) !== -1}
          onChange={() => {
            const index = value.indexOf(department.id);
            if (index > -1) {
              const withoutId = value.filter((id) => id !== department.id);
              onChange(withoutId);
            } else {
              onChange(value.concat(department.id));
            }
          }}
        >
          {department.name}
        </Checkbox>
      ))}
    </div>
  );
}

export default OrganizerSelect;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Reports/components/OrganizerSelect.tsx